import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import Seo from "@/components/Seo";
import { usePage } from "@/lib/usePage";

const DEFAULTS = {
  seo_title: "Contact — HORS SIGNAL",
  seo_description: "Contactez HORS SIGNAL pour rejoindre une expédition.",
  kicker: "",
  title: "",
  email: "contact@horssignal.com",
  success_title: "✓ Reçu.",
  success_text: "Nous revenons vers vous. En toute discrétion.",
};

export default function Contact() {
  const { t, lang } = useI18n();
  const { content: c } = usePage("contact", DEFAULTS);
  const [form, setForm] = useState({ name: "", email: "", type: "candidature", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", form); setSent(true); toast.success("✓"); }
    catch { toast.error("Erreur"); }
  };

  return (
    <div className="pt-32 pb-24">
      <Seo lang={lang} path="/contact" title={c.seo_title || DEFAULTS.seo_title} description={c.seo_description || DEFAULTS.seo_description} />
      <div className="mx-auto max-w-4xl px-6 sm:px-12">
        {c.kicker && <span className="font-mono-hs text-xs text-[#BC5D2E] tracking-widest uppercase">{c.kicker}</span>}
        <h1 className="font-clash font-bold text-5xl sm:text-7xl uppercase tracking-tighter mt-4">{c.title || t("contact_title")}</h1>
        <a href={`mailto:${c.email || DEFAULTS.email}`} className="inline-block mt-4 font-mono-hs text-sm text-[#BC5D2E] hover:text-white tracking-widest" data-testid="contact-email-display">{c.email || DEFAULTS.email}</a>

        {sent ? (
          <div className="mt-16 border border-[#BC5D2E]/50 bg-[#141414] p-12 text-center" data-testid="contact-success">
            <p className="font-clash text-2xl uppercase tracking-tight text-[#BC5D2E]">{c.success_title || DEFAULTS.success_title}</p>
            <p className="text-[#A3A3A3] mt-3">{c.success_text || DEFAULTS.success_text}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-12 space-y-8 max-w-2xl" data-testid="contact-form">
            <div className="flex gap-3 flex-wrap">
              {[["candidature", "Rejoindre une expédition"], ["proposer", "Proposer une expérience"], ["presse", "Presse / Média"]].map(([v, l]) => (
                <button key={v} type="button" onClick={() => setForm({ ...form, type: v })} data-testid={`contact-type-${v}`}
                  className={`px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${form.type === v ? "bg-[#BC5D2E] border-[#BC5D2E] text-white" : "border-white/20 text-[#A3A3A3] hover:border-white/50"}`}>{l}</button>
              ))}
            </div>
            <input required placeholder={t("your_name")} value={form.name} onChange={set("name")} className="hs-input" data-testid="contact-name" />
            <input required type="email" placeholder={t("your_email")} value={form.email} onChange={set("email")} className="hs-input" data-testid="contact-email" />
            <textarea required placeholder={t("message")} value={form.message} onChange={set("message")} rows={5} className="hs-input resize-none" data-testid="contact-message" />
            <button className="bg-[#BC5D2E] text-white px-10 py-4 uppercase tracking-widest text-sm hover:bg-[#8A281E] transition-colors" data-testid="contact-submit">{t("send")}</button>
          </form>
        )}
      </div>
    </div>
  );
}
